<script setup>
const { data } = await useAsyncData("navigation", () => {
  return queryCollectionNavigation("pomoc").order("date", "DESC");
});
</script>

<template>
  <div class="bg-white shadow-xl text-gray-800">
    <div class="max-w-7xl mx-auto py-6 grid grid-cols-4 gap-8">
      <div
        class="uppercase text-center font-extrabold text-2xl font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
      >
        Przydatne informacje
      </div>
      <div class="col-span-3"></div>

      <FlexuilibMagicLottie src="/lottie/help.json" />

      <div class="col-span-3 flex flex-col gap-2 justify-start">
        <NuxtLink
          v-for="(item, i) in data[0].children"
          :key="i"
          :to="item.path"
          class="text-lg font-semibold hover:text-blue-600 transition-colors"
        >
          {{ item.title }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
